<template>
  <v-container grid-list-md class="pa-3">
    <v-layout justify-center>
      <v-flex xs12 sm10 md6>
        <v-card flat class="v2-card">
          <v-card-title>Request Adjustment</v-card-title>
          <v-card-text>
            <v-form onSubmit="return false;" ref="form" lazy-validation>
              <p class="v2-muted">You can respond to us requesting a different amount or reply below with questions.</p>
              <vue-editor placeholder="Message to us" v-model="iso_message" :editorToolbar="customToolbar"></vue-editor>
              <div class="text-xs-center mt-3">
                <v-btn color="primary" depressed @click="sendNotification" :disabled="progressModel">Submit</v-btn>
              </div>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { VueEditor } from 'vue2-editor'
import accountingReply from '../mixins/accountingReply'

export default {
  mixins: [accountingReply],
  components: { VueEditor },
}
</script>
